module.exports = __webpack_public_path__ + "img/banner2.75f50a09.jpg";